let cspg = [
  {
    path: '/cspg_index',
    name: '滇医通-南方电网企业服务',
    component: () => import('@/pages/cspg/index')
  },
  {
    path: '/cspg_doctor_list',
    name: '滇医通-南方电网企业服务',
    component: () => import('@/pages/cspg/doctor-list')
  },
  {
    path: '/cspg_doctor_detail',
    name: '滇医通-南方电网企业服务',
    component: () => import('@/pages/cspg/doctor-detail')
  },
  {
    path: '/cspg_order_list',
    name: '滇医通-南方电网企业服务',
    component: () => import('@/pages/cspg/order-list')
  },
  {
    path: '/cspg_report',
    name: '滇医通-南方电网企业服务-体检报告',
    component: () => import('@/pages/cspg/report')
  },
  {
    path: '/cspg_report_detail',
    name: '滇医通-南方电网企业服务-报告详情',
    component: () => import('@/pages/cspg/report-detail')
  },
  {
    path: '/cspg_profile',
    name: '滇医通-南方电网企业服务-个人中心',
    component: () => import('@/pages/cspg/profile')
  },
  {
    path: '/cspg_archive',
    name: '滇医通-南方电网企业服务-健康档案',
    component: () => import('@/pages/cspg/archive')
  },
  {
    path: '/cspg_followup',
    name: '滇医通-南方电网企业服务-随访任务',
    component: () => import('@/pages/cspg/followup')
  },
  {
    path: '/cspg_followup_detail',
    name: '滇医通-南方电网企业服务-随访详情',
    component: () => import('@/pages/cspg/followup-detail')
  },
  {
    path: '/cspg_live',
    name: '滇医通-南方电网企业服务-健康大讲堂',
    component: () => import('@/pages/cspg/live')
  },
]

export default cspg
